// Botões da barra de ferramentas da lista que podem ser escondidos.
//
// Ficam de fora, sempre visíveis: a busca, o botão de filtros, o de layout
// (é onde esta escolha mora) e o par Abertos/Fechados — esconder esse último
// deixaria os resolvidos sem caminho.
export const FERRAMENTAS_DA_LISTA = [
	{ id: "todos", rotulo: "Ver os de todo mundo", dica: "Mostra também os atendimentos dos colegas, não só os seus." },
	{ id: "novo", rotulo: "Novo atendimento", dica: "Começa uma conversa com um contato, sem esperar ele chamar." },
	{ id: "favoritas", rotulo: "Favoritas", dica: "Mostra só os atendimentos marcados com estrela." },
	{ id: "adiados", rotulo: "Pausa", dica: "Atendimentos pausados para retomar mais tarde." },
	{ id: "resolverTodos", rotulo: "Resolver todos", dica: "Encerra vários atendimentos da lista de uma vez." },
	{ id: "transferirTodos", rotulo: "Transferir todos", dica: "Passa vários atendimentos de uma vez para outra pessoa ou departamento." },
	{ id: "ordem", rotulo: "Ordenação", dica: "Põe a lista em ordem de nome (A–Z) em vez da mais recente." },
	{ id: "visoes", rotulo: "Visões salvas", dica: "Guarda uma combinação de filtros para voltar a ela com um clique." },
];

// Ids acrescentados depois que esta preferência já existia. Ver `comNovos` em services/prefsTickets.js.
export const FERRAMENTAS_NOVAS = ["transferirTodos"];

export const IDS_FERRAMENTAS_DA_LISTA = FERRAMENTAS_DA_LISTA.map((f) => f.id);
